import { createContext, useContext } from "react";

export interface ConfiguratorPageCustomization {
  forceShowCAD: boolean;
  showRegistrationBanner: boolean;
  showRequestOffer: boolean;
  showSave: boolean;
  showPrice: boolean;
  showAvailability: boolean;
  embedded: boolean;
}

export const ConfiguratorPageCustomizationContext = createContext<ConfiguratorPageCustomization>({
  forceShowCAD: false,
  showRegistrationBanner: true,
  showRequestOffer: true,
  showSave: true,
  showPrice: true,
  showAvailability: true,
  embedded: false,
});

export const useConfiguratorPageCustomization = () => useContext(ConfiguratorPageCustomizationContext);
